import { connect } from 'react-redux';
import ProductTagWizardDebugger from '../components/ProductTagWizard/Debugger';
import { requestAllProducts, setProductList } from '../actions/tagWizardActions';
import { setTagData, exportData, copyData, setupEditor, changeCurrentSideMask, exportSVGs } from '../actions/editorActions';
import { setupCanvases, resetCanvases } from '../actions/canvasActions';
import { modifyForNLIS } from '../actions/tagWizardDebuggerActions';

const mapStateToProps = function(store) {
    const tagWizardState = store.tagWizard.present;
    const editorState = store.editor.present;
    const { canvas, revealBackSideBool } = editorState;

    return {
        isTagWizardLoading: tagWizardState.isLoading,
        isEditorLoading: editorState.loading,
        exportedSVGs: exportSVGs(editorState),
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        setTagData: (data) => dispatch(setTagData(data)),
        resetCanvases: () => dispatch(resetCanvases()),
        setupCanvases: (data) => dispatch(setupCanvases()),
        exportData: () => dispatch(exportData()),
        copyData: () => dispatch(exportData({ isCopy: true })),
        refreshProductRequest: () => {
            dispatch(setProductList({})),

            Promise.all([
                dispatch(requestAllProducts()),
            ]).then(() => {
                dispatch(setupEditor());
            });
        },
        modifyForNLIS: () => dispatch(modifyForNLIS()),
        changeCurrentSideMask: (mask) => dispatch(changeCurrentSideMask(mask)),
    };
};
const ConnectedProductTagWizardDebuggerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductTagWizardDebugger);

export default ConnectedProductTagWizardDebuggerContainer;
